import { Fragment } from 'react';
import { useCookies } from "react-cookie";
import { Text } from '../../FormControls/Text';
import { List } from '../../FormControls/List';
import { Stack } from '../../FormControls/Stack';
import { Input } from '../../FormControls/Input';
import { Report } from '@mui/icons-material'

import { ScreenControl } from '../ScreenControl';
import { setAddress, setAlias, setNetwork, registerWallet } from '../../../../main/slices/blockchainSlice';
import { setStoreId } from '../../../../main/slices/bussinessSlice';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingComponent } from '../../LoadingComponent';
import { registerBitpos } from '../../../../main/slices/userSlice';

const NetworkSelector = ({ onChange, network, networks, crypto }) => {
    
    let nets = [];
    if(crypto == "BTC") networks.forEach(n => { if(n.id != "Ethereum (ERC20)") nets.push(n) })
    networks = crypto == "BTC" ? nets : networks

    return (
        <Fragment>

            <Stack flex={{ flexDirection: "column" }}>
                <Text classes={["subtitle"]}> Agreguemos tu wallet </Text>
                <Text classes={["title"]}> Selecciona una red blockchain </Text>
            </Stack>

            {networks.length ? <List
                items={networks}
                def={network}
                onSelect={(s) => onChange("network", s)}
                keys={{ img: "logo", text: "value", id: "id" }}
            />
                : <LoadingComponent />
            }

        </Fragment>
    )
}

const WalletDetails = ({ onChange, address, alias }) => {

    return (
        <Fragment>

            <Stack flex={{ flexDirection: "column" }}>
                <Text classes={["subtitle"]}> Agreguemos tu wallet </Text>
                <Text classes={["title"]}> Selecciona una red blockchain </Text>
            </Stack>

            <Stack flex={{ flexDirection: "column" }}>

                {//INVALIR WALLET ALERT
                    (address.length > 0 && address.length < 20) &&
                    <Text classes={["description", "alignContent", "error"]} style={{ "justifyContent": "flex-start", "margin": "0.5em 0" }}>
                        <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                        Wallet no válida
                    </Text>
                }

                <Input
                    attributes={{ value: address }} type="text" classes={["marginTB1em"]}
                    onChange={({ target }) => onChange("address", target.value)} placeHolder="Dirección wallet"
                />
                <Input
                    attributes={{ value: alias }} type="text" classes={["marginTB1em"]}
                    onChange={({ target }) => onChange("alias", target.value)} placeHolder="Alias • opcional"
                />
            </Stack>

        </Fragment>
    )
}


export const CryptoPayment = ({ path }) => {

    const dispatch = useDispatch();
    const [cookies] = useCookies(["token", "u", "Store"]);
    const state = useSelector(({ blockchain }) => blockchain);

    const handleChange = (key, value) => {
        if (key === "network") dispatch(setNetwork({ value, error: !value }));
        else if (key === "address") dispatch(setAddress({ value, error: !value }));
        else if (key === "alias") dispatch(setAlias({ value, error: !value }));
    }

    const submitWallet = async () => {
        const { response } = await dispatch(registerWallet({
            "id": decodeURIComponent(cookies.token),
            "u": decodeURIComponent(cookies.u)
        })).unwrap();
        if (response.ok === true) return await submitBitpos();
        else return false;
    }

    const submitBitpos = async () => {
        const { response } = await dispatch(registerBitpos({ "storeID": cookies["Store"] })).unwrap();
        if (!response.error && response.ok === true) {dispatch(setStoreId(response.store)); return true;}
        else return false;
    }

    const route = (path) => {
        // FOR THE PATH "phone"
        if (path === "network") return {
            index: { fw: -1 },          // IF fw = -1, STAYS IN THE CURRENT SCREEN TRIGGER BY THE FORWARD BUTTON
            path: "wallet",    // THE NEXT PATH THE COMPONENT IS GOING TO RENDER
            disabled: state.network.error
        }
        // FOR THE PATH "utp"
        else if (path === "wallet") return {
            index: { bw: -1 },  // IF bw = -1, STAYS IN THE CURRENT SCREEN TRIGGER BY THE BACKWARD BUTTON
            path: "network",    // THE NEXT PATH THE COMPONENT IS GOING TO RENDER
            disabled: state.address.error || state.address.value.length < 20,
            beforeSubmit: () => submitWallet()
        }
    }

    return (
        <Fragment>

            {/* NETWORK COMPONENT */}
            {path === "network" && <NetworkSelector
                onChange={handleChange}
                network={state.network.value}
                networks={state.networks[state.crypto.value]}
                crypto={state.crypto.value}
            />}

            {/* WALLET COMPONENT */}
            {path === "wallet" && <WalletDetails
                onChange={handleChange}
                alias={state.alias.value}
                address={state.address.value}
            />}

            <ScreenControl {...route(path)} >
            </ScreenControl>
        </Fragment>
    )
}